// Domain-based brand routing for MulletMayhem & Bogan Empire
(function() {
  const currentHost = window.location.hostname;
  const currentPath = window.location.pathname;
  const isBogan = currentHost.includes('boganempire') || currentHost.includes('boganmerch');
  
  // Add brand class to body for CSS targeting
  document.body.classList.add(isBogan ? 'brand-bogan-empire' : 'brand-mullet-mayhem');
  
  // Store brand in sessionStorage
  sessionStorage.setItem('currentBrand', isBogan ? 'bogan-empire' : 'mullet-mayhem');
  
  const isThemeEditor = window.Shopify && window.Shopify.designMode;

if (!isThemeEditor && (currentPath === '/' || currentPath === '')) {
  if (isBogan && !window.location.search.includes('view=bogan')) {
    window.location.href = '/?view=bogan';
  } else if (!isBogan && window.location.search.includes('view=bogan')) {
    window.location.href = '/';
  }
}

  
  // Wait for DOM to be ready for menu filtering
  document.addEventListener('DOMContentLoaded', function() {
    const allMenus = document.querySelectorAll('nav, [role="navigation"], .header__menu');
    
    allMenus.forEach(menu => {
      const menuLinks = menu.querySelectorAll('a');
      
      menuLinks.forEach(link => {
        const linkText = link.textContent.toLowerCase();
        const linkHref = link.getAttribute('href') || '';
        
        if (!isBogan) {
          if (linkText.includes('bogan') || 
              linkHref.includes('bogan') ||
              linkText.includes('enter the empire')) {
            const parentItem = link.closest('li') || link.closest('.menu-item');
            if (parentItem) parentItem.style.display = 'none';
          }
        }
        
        if (isBogan) {
          if (linkText.includes('mullet') || 
              linkHref.includes('mullet') ||
              linkText.includes('shop mullet mayhem')) {
            const parentItem = link.closest('li') || link.closest('.menu-item');
            if (parentItem) parentItem.style.display = 'none';
          }
        }
      });
    });
  });
})();
